import { Row } from "@hightouch/htui";
import { useNavWidth } from "src/contexts/nav-width-context";
import { FullLogo } from "./logos";
import { NavToggleButton } from "./toggle-button";
import { useUser } from "src/contexts/user-context";

/**
 * Navigation header displays the logo and a button to toggle the sidebar.
 */
export function NavHeader({
  showToggleHoverState = false,
}: {
  showToggleHoverState?: boolean;
}) {
  const { isNavOpen } = useNavWidth();
  const { user } = useUser();

  const orgLogo = user?.organization?.logo_url;

  return (
    <Row
      as="header"
      aria-label="Navigation header"
      align="center"
      gap={2}
      h={orgLogo ? 10 : 8}
      justify={isNavOpen ? "space-between" : "center"}
      pl={orgLogo && isNavOpen ? 0 : 2}
      px={2}
      pr={isNavOpen ? 0 : 2} // Only have left padding on expanded state, since toggle button has it's own padding for hover state.
      py={1}
    >
      {isNavOpen && <FullLogo />}
      <NavToggleButton showHoverState={showToggleHoverState} />
    </Row>
  );
}
